import type { ConnectionPlatform } from 'honeygrid-types/validators-and-types/ConnectionTypes'

export type ManagedConnection = {
	id: string
	displayName: string
	description: string
	logoSrc: string
	platform?: ConnectionPlatform // Only set if it maps to a DB platform
}

/**
 * HoneyGrid-managed connections available to all workspaces.
 * These are platform integrations that HoneyGrid provides out of the box.
 *
 * Note: Only connections with a `platform` field can sync with actual API connections.
 * Others are UI-only placeholders for future integrations.
 */
export const MANAGED_CONNECTIONS: ManagedConnection[] = [
	{
		id: 'chatgpt',
		displayName: 'ChatGPT',
		description: 'Lead management, strategy, planning',
		logoSrc: '/brands/chatgpt.svg',
	},
	{
		id: 'cloudflare',
		displayName: 'Cloudflare',
		description: 'Domain, email, fast-loading mobile landing pages',
		logoSrc: '/brands/cloudflare.svg',
	},
	{
		id: 'google_ads',
		displayName: 'Google Ads',
		description: 'Campaigns, conversions',
		logoSrc: '/brands/google-ads.svg',
		platform: 'google_ads',
	},
	{
		id: 'meta_ads',
		displayName: 'Meta Ads',
		description: 'Campaigns, conversions',
		logoSrc: '/brands/meta.svg',
	},
	{
		id: 'twilio',
		displayName: 'Twilio',
		description: 'Phone numbers, voice, SMS',
		logoSrc: '/brands/twilio.svg',
	},
]